import { render } from "./kalio-job-application-card.vue?vue&type=template&id=3885b5e2"
import script from "./kalio-job-application-card.vue?vue&type=script&lang=js"
export * from "./kalio-job-application-card.vue?vue&type=script&lang=js"

import "./kalio-job-application-card.vue?vue&type=style&index=0&id=3885b5e2&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__